import ScrollReveal from 'scrollreveal';

ScrollReveal().watch = function (target, onEnter, onExit) {
    onExit = onExit || function () {}

    if (typeof onEnter === 'function' && typeof onExit === 'function') {
        var noEffect = {
            delay:    0,
            distance: 0,
            duration: 0,
            scale:    1,
            opacity:  null,
            rotate:   { x: 0, y: 0, z: 0, },
            reset: true,
            beforeReset: onExit,
            beforeReveal: onEnter,
        }
        this.reveal(target, noEffect)
    } else {
        throw new Error('Watch received invalid arguments.')
    }
}

var slideRight = {
	delay: 100,
	distance: '120px',
	duration: 1000,
	origin: 'left',
	opacity: 0,
};

var slideLeft = {
	delay: 250,
	distance: '120px',
	duration: 1000,
	origin: 'right',
	opacity: 0,
};

var fadeIn = {
	delay: 200,
	duration: 1000,
	opacity: 0,
};

ScrollReveal().reveal('.will-slide-right', slideRight);
ScrollReveal().reveal('.will-slide-left', slideLeft);
ScrollReveal().reveal('.will-fade-in', fadeIn);
ScrollReveal().watch('.eb-c-products-showcase__rotation-trigger', function onEnter (el) {
	el.parentElement.classList.remove('has-rotation');
})
